/**
 * What the player reads for a refusal. A server sentence is shown as sent; a
 * refusal that arrives without one is answered the way the 2014 client
 * answered its bare failure packet: with its own `localeInfo` string, or with
 * nothing where 2014 showed nothing. `refusaltext.json` holds one entry per
 * notice code the server sends without text, each citing its 2014 line.
 */
import table from "./refusaltext.json";

type Entry = { code: number; text?: string };

const BY_CODE = new Map<number, string>(
  Object.values(table as Record<string, Entry>)
    .filter((entry) => entry.text !== undefined)
    .map((entry) => [entry.code, entry.text!.replaceAll("[ENTER]", "\n")]),
);

export function refusalText(code: number, text: string): string {
  if (text.length > 0) return text;
  return BY_CODE.get(code) ?? "";
}
